
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"62","height":"63","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M52.63 14.9c-5.565-5.422-14.562-5.422-20.128 0L31 16.364 29.498 14.9c-5.566-5.422-14.563-5.422-20.129 0a13.76 13.76 0 000 19.8l19.828 19.317a2.583 2.583 0 003.606 0L52.63 34.699a13.76 13.76 0 000-19.799z","fill":"#313131"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h62v62H0z"}})])])]);
        };
      

        module.exports = {
          
          render: render,
        };
      